import * as React from "react";
import {
  Create,
  SimpleForm,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { EMAIL_SERVICES_STATUSES } from "@local/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";
import EmailServices from "./emailServices.js";

const EmailConnectors = [
  { name: "mailjet", id: "mailjet" },
  { name: "mailtrap", id: "mailtrap" },
  { name: "emailjs", id: "emailjs" },
  { name: "sendgrid", id: "sendgrid" },
  { name: "nodemailer", id: "nodemailer" },
];

const EmailServiceCreate = () => {
  const [selectedEmail, setSelectedEmail] = React.useState("");

  return (
    <Create redirect="list">
      <SimpleForm toolbar={<CustomToolbar />}>
        <SelectInput
          source="name"
          choices={EmailConnectors}
          value={selectedEmail}
          onChange={(e) => setSelectedEmail(e.target.value)}
          validate={[required()]}
        />
        <TextInput
          source="config.email"
          validate={[required()]}
          inputProps={{ maxLength: 255 }}
        />
        {selectedEmail && EmailServices[selectedEmail].create()}
        <SelectInput
          source="status"
          validate={[required()]}
          choices={Object.keys(EMAIL_SERVICES_STATUSES).map((status) => ({
            id: status,
            name: `resources.EmailService.source.status.${status}`,
          }))}
        />
      </SimpleForm>
    </Create>
  );
};

export default EmailServiceCreate;
